var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvVizioStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7416_6234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93799 6.00203L9.99812 9.28369L9.99863 9.28315L9.9988 9.28369L14.0614 6.00015C12.9593 6.23008 11.5421 6.36856 9.99537 6.36856C8.45285 6.36856 7.03887 6.23087 5.93799 6.00203Z",
    fill: "#100F0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99817 11.1548L4.53887 6.87648C2.8615 6.67481 1.32823 6.38303 0 6.02006L9.99834 14L20.0002 6.02016C18.6756 6.38209 17.1473 6.67323 15.4755 6.87485L9.99817 11.1548Z",
    fill: "#100F0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7416_6234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 8,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvVizioStore);
export default __webpack_public_path__ + "static/media/ctv_vizio_store.781998f05e96a2be22669d3b3a1c94eb.svg";
export { ForwardRef as ReactComponent };